import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, PaginatedKiloClassTypeList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompleteClassType {
  search?: string;
}

function useAutoCompleteClassType({
  search,
}: IUseAutoCompleteClassType): UseQueryResult<AxiosResponse<PaginatedKiloClassTypeList>> {
  const fetchAutoCompleteClassType = (): Promise<AxiosResponse<PaginatedKiloClassTypeList>> => {
    const params: UrlParams = { limit: '100', offset: '0' };

    if (search) {
      params.search = search;
    }

    return client.get(`kilo-class-types/auto_complete/?${encodeUrlParams(params)}`);
  };

  return useQuery(['classType', search], fetchAutoCompleteClassType);
}

export default useAutoCompleteClassType;
